import script from "./BookingAppDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingAppDownload.vue?vue&type=script&setup=true&lang=js"

import "./BookingAppDownload.vue?vue&type=style&index=0&id=8e77d2f4&lang=scss"

const __exports__ = script;

export default __exports__